import { Component, OnDestroy, OnInit } from '@angular/core';
import { MainBodyBottomComponentService } from '@carm/base-layout/main/main-body/main-body-bottom/services/main-body-bottom-component.service';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@carm/_utils/base.component';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'carm-main-body-bottom',
  templateUrl: './main-body-bottom.component.html',
  styleUrls: ['./main-body-bottom.component.scss'],
})
export class MainBodyBottomComponent extends BaseComponent implements OnInit, OnDestroy {

  public version: string = '';
  public angularTag: string = '';
  public hybrisTag: string;
  public node: string;

  constructor(private mainBodyBottomComponent: MainBodyBottomComponentService) {
    super();
  }

  ngOnInit(): void {
    const element = document.getElementById('buildTag');

    if(element) {
      const elAttribute = element.getAttribute('buildtag');
      const dashIndex =  elAttribute.indexOf('-') + 1;

      if (dashIndex !== -1) {
        const contentAfterDash = elAttribute.substring(dashIndex);
        this.angularTag = contentAfterDash;
      } else {
        console.log('Dash not found');
      }
    }

    this.mainBodyBottomComponent
    .getHybrisTag()
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      const elAttribute = element.getAttribute('buildtag');
      const localBuildVersion =elAttribute?.substring(1, 6);
      const hVersionNum = res.hybrisVersionID?.substring(1, 6);
      const aVersionNum = res.angularVersionID?.substring(1, 6);
      this.hybrisTag = res.hybrisVersionID?.substring(res.hybrisVersionID?.indexOf('-') + 1);
      this.version = hVersionNum;
      if(environment.showNodeId){
        this.node = res.hybrisNodeID;
      }
      if(aVersionNum != undefined && hVersionNum < aVersionNum) {
        this.version = aVersionNum;
      } else if (aVersionNum != undefined && localBuildVersion > aVersionNum && hVersionNum < localBuildVersion) {
        this.version = localBuildVersion;
      }
    });
  }
}
